import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const RekapModal = ({ toggleModal }) => {
  const dosenOption = [
    { value: "All", label: "Semua Dosen" },
    { value: "Purnamawati Tjhin", label: "Purnamawati Tjhin" },
    { value: "Eveline Margo", label: "Eveline Margo" },
    { value: "Tjam Diana Samara", label: "Tjam Diana Samara" },
  ];

  const kelompokOption = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
  ];

  const tipeOption = [
    { value: 1, label: "TUTORIAL" },
    { value: 2, label: "PLENO" },
    { value: 3, label: "KKD" },
    { value: 4, label: "PERKULIAHAN" },
    { value: 5, label: "PRAKTIKUM" },
  ];
  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Rekap Pertemuan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Dari Tanggal</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Sampai Tanggal</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Kelompok Modul</label>
          <Select options={kelompokOption} isMulti />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Tipe Pertemuan</label>
          <Select options={tipeOption} />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Dosen</label>
          <Select options={dosenOption} isMulti />
        </div>

        <button className="btn w-100 btn-success" onClick={closeModal}>
          Tambah
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default RekapModal;
